import { fmtRp, branchLabel } from '../lib/api';

export default function Receipt({ tx }) {
  if (!tx) return null;
  const dateStr = tx.date_wib ? tx.date_wib.split('-').reverse().join('/') : '';
  return (
    <div id="thermal-receipt" data-testid="thermal-receipt"
      className="w-[280px] max-w-full mx-auto font-mono text-[11px] leading-snug p-3 border border-line rounded-lg shadow-sm">
      <div className="text-center">
        <p className="text-base font-bold tracking-widest">LODISHOES</p>
        <p>Sepatu & Sandal Original</p>
        <p>Cabang {branchLabel(tx.branch)}</p>
      </div>
      <p className="border-t border-dashed border-gray-400 my-2" />
      <div className="flex justify-between"><span>No: {tx.invoice_no}</span></div>
      <div className="flex justify-between"><span>{dateStr} {tx.time_wib || ''}</span><span>Kasir: {tx.cashier_name}</span></div>
      {tx.customer_name && <p>Pembeli: {tx.customer_name}</p>}
      {tx.customer_wa && <p>WA: {tx.customer_wa}</p>}
      <p className="border-t border-dashed border-gray-400 my-2" />
      {tx.items.map((item, i) => (
        <div key={i} className="mb-1">
          <p className="font-semibold">{item.article}{item.brand ? ` (${item.brand})` : ''}</p>
          <div className="flex justify-between">
            <span>Uk {item.size} x{item.qty} @{fmtRp(item.price)}</span>
            <span>{fmtRp(item.line_total)}</span>
          </div>
        </div>
      ))}
      <p className="border-t border-dashed border-gray-400 my-2" />
      <div className="flex justify-between"><span>Subtotal</span><span>{fmtRp(tx.subtotal)}</span></div>
      {tx.discount_amount > 0 && (
        <div className="flex justify-between">
          <span>Diskon{tx.discount_type === 'percent' ? ` (${tx.discount_value}%)` : ''}</span>
          <span>-{fmtRp(tx.discount_amount)}</span>
        </div>
      )}
      <div className="flex justify-between font-bold text-[13px] mt-1">
        <span>TOTAL</span><span data-testid="receipt-total">{fmtRp(tx.total)}</span>
      </div>
      <div className="flex justify-between mt-1">
        <span>Bayar ({tx.payment_method === 'cash' ? 'Tunai' : tx.payment_method.toUpperCase()})</span>
        <span>{fmtRp(tx.cash_paid)}</span>
      </div>
      {tx.payment_method === 'cash' && (
        <div className="flex justify-between"><span>Kembali</span><span>{fmtRp(tx.change)}</span></div>
      )}
      <p className="border-t border-dashed border-gray-400 my-2" />
      <div className="text-center">
        <p className="font-semibold">Terima kasih sudah belanja di LodiShoes!</p>
        <p>Barang yang sudah dibeli tidak dapat ditukar/dikembalikan.</p>
      </div>
      {tx.status === 'cancelled' && (
        <p className="text-center font-bold mt-2 border border-black px-2 py-1">*** TRANSAKSI DIBATALKAN ***</p>
      )}
    </div>
  );
}
